export const encodeDate = (date) => {
    if (!date) return "";
    return date.format("YYYY-MM-DD HH:mm:ss");
};
